<template>
  <div
    :class="[
      'flex flex-wrap lg:flex-nowrap justify-between items-center px-6 lg:h-20 w-full top-0 left-0 z-50 bg-white',
    ]"
  >
    <!-- CareerWise logo -->
    <a href="/">
      <img class="py-2" src="/img/cw-logo.png" alt="CareerWise logo" />
    </a>
    <!-- /CareerWise logo -->

    <!-- Menu content -->
    <div class="hidden md:flex h-full space-x-4 items-center">
      <button class="btn btn-cw-700 mb-0 font-nunito" @click="routeTo('Home')">
        Find out more about CareerWise
      </button>
    </div>
    <!-- /Menu content -->

    <!-- Mobile menu -->
    <!--
      <div class="flex md:hidden">
      <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      class="cursor-pointer h-8 w-8 hover:text-cw-700"
      @click="toggleMobileMenu"
      >
      <path
      data-v-3ef16b00=""
      fill-rule="evenodd"
      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
      clip-rule="evenodd"
      />
      </svg>
      <Transition name="fade">
      <div
      v-if="isMobileMenuOpen"
      class="absolute left-0 top-0 flex flex-col h-screen w-screen sm:space-x-4 items-center justify-center bg-white"
      >
      <svg
      xmlns="http://www.w3.org/2000/svg"
      class="absolute top-12 right-12 cursor-pointer h-8 w-8 hover:text-cw-700"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      @click="toggleMobileMenu"
      >
      <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M6 18L18 6M6 6l12 12"
      />
      </svg>
      <a
      v-for="(item, i) in menuItems"
      :key="i"
      class="font-nunito text-3xl py-4 m-0 cursor-pointer no-underline hover:text-cw-700 text-center"
      @click="routeTo(item.routeName)"
      >
      {{ item.name }}
      </a>

      <a
      href="/account"
      class="font-nunito text-3xl py-4 m-0 cursor-pointer no-underline hover:text-cw-700"
      >
      Sign in
      </a>
      </div>
      </Transition>
      </div> 
    -->
    <!-- /Mobile menu -->
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

export default defineComponent({
  name: 'Menu',

  setup() {
    const router = useRouter()

    const menuItems = []

    const isMobileMenuOpen = ref(false)
    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value.val
    }

    const routeTo = (name) => {
      router.push({ name })
    }

    return { menuItems, isMobileMenuOpen, toggleMobileMenu, routeTo }
  },
})
</script>
